module.exports = __webpack_public_path__ + "fonts/baronsans-light-webfont.a49fe4e0.woff2";